export const HOSTED_ALIAS_PATTERN = /^[a-z0-9]+$/;

type DomainAddress = {
  domain_name: string;
  customer_alias?: string | null;
};

export const addressChanges = (domain: DomainAddress, form: { domain_name: string; customer_alias: string }) => {
  const changes: { domain_name?: string; customer_alias?: string } = {};
  const name = form.domain_name.trim();
  if (name !== domain.domain_name) changes.domain_name = name;
  if (form.customer_alias !== domain.customer_alias) changes.customer_alias = form.customer_alias;
  return changes;
};

export const hostedAddress = (domainUrl: string, alias: string) => {
  try {
    return `${new URL(domainUrl).origin}/${alias}`;
  } catch {
    return alias;
  }
};

// A 5xx detail is internal error text, so only the reasons for a rejected request are shown.
export const rejectionMessage = (error: unknown, fallback: string) => {
  const response = error as { status?: number; data?: { detail?: string } } | undefined;
  const rejected = response?.status === 400 || response?.status === 409;
  return rejected && response?.data?.detail ? response.data.detail : fallback;
};
